import * as React from 'react';
import {
    Box,
    Checkbox,
    createStyles,
    ListItem,
    makeStyles,
    Radio,
    Theme,
    Typography
} from '@material-ui/core';
import { addOpacity } from 'lib/helpers';
import { useCurrencyString } from 'lib/useCurrencyString';
import { IAdjustmentLocalResource } from 'components/order/model/Order';
import { isString } from 'lib/typeInference';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        rewardPrice: {
            color: addOpacity(theme.palette.text.primary, 0.6)
        }
    })
);

interface IProps {
    award: IAdjustmentLocalResource;
    onClick: (awardId: string) => void;
    selected?: boolean;
    multi?: boolean;
}

export const ViewBasketAwardItem: React.FC<IProps> = ({ award, onClick, selected, multi }) => {
    const classes = useStyles();
    const getCurrencyString = useCurrencyString();
    const handleRewardClick = React.useCallback(
        () => onClick && isString(award.awardId) && onClick(award.awardId),
        [onClick, award.awardId]
    );
    return (
        <ListItem disableGutters button onClick={handleRewardClick}>
            <Box display="flex" alignItems="center" width="100%">
                <Box display="flex" flexDirection="column" marginRight="auto">
                    <Typography>{award.description}</Typography>
                    <Typography className={classes.rewardPrice}>
                        {getCurrencyString(award.totalValue)}
                    </Typography>
                </Box>
                {multi ? <Checkbox checked={selected} /> : <Radio checked={selected} />}
            </Box>
        </ListItem>
    );
};
